// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_article_paiement {
    padding: 0 100px;
    text-align: center;
}

.paiement_body {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.btn_boost_confirm {
    width: 300px;
}

.btn_boost_confirm {
    background-color: var(--couleur-principale);
    color: var(--white-principale);
    border-radius: 30px;
    padding: 10px 30px;
    border: none;
    margin-left: auto;
}

.btn_boost_confirm:hover {
    background-color: var(--couleur-secondaire);
    color: var(--white-principale);
}

.btn_boost_confirm.disabled {
  background: var(--gris-secondaire) !important;
  cursor: not-allowed;
  opacity: 0.6;
}


.free_payment_text {
    font-size: 18px;
    color: var(--couleur-secondaire);
    font-weight: bold;
}

.free_payment_note{
    min-height: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

@media (max-width: 768px) {
    .content_article_paiement {
        padding: 0 10px;
        text-align: center;
    }

    .btn_boost_confirm {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/article/ArticlePaiementPage.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,2CAA2C;IAC3C,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;IAC3C,8BAA8B;AAClC;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,YAAY;AACd;;;AAGA;IACI,eAAe;IACf,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".content_article_paiement {\n    padding: 0 100px;\n    text-align: center;\n}\n\n.paiement_body {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.btn_boost_confirm {\n    width: 300px;\n}\n\n.btn_boost_confirm {\n    background-color: var(--couleur-principale);\n    color: var(--white-principale);\n    border-radius: 30px;\n    padding: 10px 30px;\n    border: none;\n    margin-left: auto;\n}\n\n.btn_boost_confirm:hover {\n    background-color: var(--couleur-secondaire);\n    color: var(--white-principale);\n}\n\n.btn_boost_confirm.disabled {\n  background: var(--gris-secondaire) !important;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n\n.free_payment_text {\n    font-size: 18px;\n    color: var(--couleur-secondaire);\n    font-weight: bold;\n}\n\n.free_payment_note{\n    min-height: 100% !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@media (max-width: 768px) {\n    .content_article_paiement {\n        padding: 0 10px;\n        text-align: center;\n    }\n\n    .btn_boost_confirm {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
